import type { EstimateHistoryPoint, Report } from "../types";

export function mergeReportHistory(report: Report): EstimateHistoryPoint[] {
  const byTimestamp = new Map<string, EstimateHistoryPoint>();
  for (const point of [...report.marketHistory, ...report.estimateHistory]) {
    const current = byTimestamp.get(point.observedAt);
    byTimestamp.set(point.observedAt, { ...current, ...point });
  }
  return [...byTimestamp.values()].sort((left, right) => left.observedAt.localeCompare(right.observedAt));
}
